import React from "react";
import { Container, ContainerTitulo, Titulo, Parrafo} from "../styles/skills";
import { ContainerGif, LogoGif,A } from "../styles/about";
import gifProgramador from "../img/programador1.gif"
const About = () => {
  return (
    <Container>
      <ContainerTitulo>
        <Titulo>Sobre mi</Titulo>
        <Parrafo>
          Estudiante de Ingeniera de Software en la <A href="https://www.unadmexico.mx/ofertaeducativa/licenciaturas/division-de-ciencias-exactas-ingenieria-y-tecnologia/desarrollo-de-software" target="_blank" rel="noreferrer">UnADM</A>, egresado del <A href="https://www.soyhenry.com/webfullstack" target="_blank" rel="noreferrer">Bootcamp de Henry</A> en
          Desarrollo Web Full Stack, soy desarrollador con experiencia académica
          en trabajo de equipo, organizado, orientado a la resolución de
          problemas, con alto desempeño al aprender tecnologías nuevas, sociable
          y con muchas ganas de sacar adelante lo que se me ponga enfrente.
        </Parrafo>
        <Parrafo>
          Desde adolescente me llamaban la atención las computadoras y los
          sistemas informáticos, a ese periodo entre al mundo de Linux, pero fue
          hasta varios años después que decidí profundizar más y encontré la
          programación, de ahí me enamore de esta profesión tan creativa y
          desafiante.
        </Parrafo>
      </ContainerTitulo>
      <ContainerGif>
        <LogoGif src={gifProgramador}/>
      </ContainerGif>
    </Container>
  );
};

export default About;
